<template>
  <div>
    <b-col cols="12" style="padding: 1.5em; margin-bottom: 0.7em; border-radius: 0.3em; background-color: #252a3e;">
      <b-row class="mb-2">
        <b-col cols="6"><h4>{{formatWeekDate(GetCurrentDay())}}, {{formatDate(GetCurrentDay())}}</h4></b-col>
        <b-col cols="6">
          <b-button @click="SendDispatch" class="btn-sm float-right" v-show="HasUserEditRight()">
            <span v-show="!loading"> VERSENDEN </span>
            <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
            <div
                v-show="loading"
                class="spinner-border spinner-border-sm"
                role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </b-button>
        </b-col>
      </b-row>
      <div class="text-center">
        <b-spinner
            v-for="variant in variants"
            :key="variant"
            :variant="variant"
            v-show="loadingList"
            class="mr-1"
            type="grow"
        />
      </div>
      <b-row>
        <b-table
            striped
            hover
            responsive
            :items="items"
            :fields="fields"
            @row-clicked="Click"
            v-show="!loadingList"
        >
          <template #cell(Action)="data">
            <b-form-checkbox
                v-show="data.item.send == null && HasUserEditRight()"
                v-model="data.item.checked"
                class="custom-control-success"
            />
          </template>

          <template #cell(Driver)="data">
            <strong>[{{ data.item.Driver.ShortName }}]</strong> {{ data.item.Driver.Name }}
          </template>
          <template #cell(Send)="data">
            <b-badge
                variant="warning"
                v-show="data.item.Send == null"
            >
              Nicht gesendet
            </b-badge>
            <b-badge
                variant="success"
                v-show="data.item.Send != null"
            >
              Gesendet: {{ formatDate(data.item.Send) }} - {{ formatTime(data.item.Send) }}
            </b-badge>
          </template>

          <template #cell(State)="data">
            <div v-show="data.item.Send != null">
              <b-badge
                  variant="danger"
                  v-show="data.item.Confirmed == null"
              >
                Nicht bestätigt
              </b-badge>
              <b-badge
                  variant="success"
                  v-show="data.item.Confirmed != null"
              >
                Bestätigt: {{ formatDate(data.item.Confirmed) }} - {{ formatTime(data.item.Confirmed) }}
              </b-badge>
            </div>

            <b-badge
                variant="dark"
                v-show="data.item.Send == null"
            >
              -
            </b-badge>
          </template>
          <template #cell(vCount)="data">
            <b-badge
                pill
                variant="light-info"
            >
              {{ data.item.vCount }}
            </b-badge>
          </template>
        </b-table>
      </b-row>
    </b-col>
  </div>
</template>


<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BSpinner, BFormTextarea, BCardText, BFormCheckbox
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { reactiveData } from 'vue-chartjs/es/mixins'

export default {
  components: {
    BSpinner,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormTextarea,
    BCardText,
    BFormCheckbox,
  },
  data() {
    return {
      variants: ['primary', 'secondary', 'danger', 'warning', 'success', 'info', 'light', 'dark'],

      loading: false,
      loadingList: true,
      fields: [
        {
          key: 'Action',
          label: '',
        },
        {
          key: 'IdentId',
          label: 'Id',
        },
        {
          key: 'Driver',
          label: 'Fahrer',
        },
        {
          key: 'Send',
          label: 'Gesendet',
        },
        {
          key: 'State',
          label: 'Status',
        },
        {
          key: 'vCount',
          label: 'Fahrten',
        },
      ],
      items: [],
    }
  },
  computed: {},
  mounted() {
    this.LoadList()
  },
  methods: {
    HasUserEditRight() {
      return this.$store.state.user.Rights.includes('R420')
    },
    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          },
      )}`
    },
    formatTime(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            hour: '2-digit',
            minute: '2-digit',
          },
      )}`
    },
    formatWeekDate(date) {
      return new Intl.DateTimeFormat('de', { weekday: 'long' }).format(date)

    },
    GetCurrentDay() {
      return new Date(this.$route.params.day);
    },
    SendDispatch() {
      if(this.loading)
        return;

      this.loading = true;
      let dispatches = [];
      this.items.forEach(i => {
        if(i.checked)
          dispatches.push(i.Driver.DriverId)
      })
      this.$http.post('/disposition/dispatches/send', JSON.stringify({
        Driver: dispatches,
        Day: new Date(this.$route.params.day)
      })).then(resp => {
        console.log(resp);
        if(resp.data.success) {

          this.loading = false;
          this.LoadList();
        }
      }).catch(err => {
        console.error(err)
      })

    },
    Click(record, index) {
      record.checked = !record.checked
    },
    LoadList() {
      this.items = [];
      this.$http.get('/disposition/dispatches/'+this.$route.params.day, { timeout: 10 * 60 * 1000 })
          .then(resp => {
            resp.data.list.forEach(i => {
              i.checked = false
              this.items.push(i)
            })
            this.loadingList = false
          })
          .catch(err => {
            console.error(err)
          })
    },
  },
}
</script>
